<div class="text-center authBody" data-testid="Authentication">
    <main class="form-signin" *ngIf="step === 1">
        <form>
            <img class="mb-4" src="/assets/logo_dark.png" alt="" height="57">

            <p>Welcome to weavix™&nbsp;Control&nbsp;Center</p>

            <mat-form-field class="w-100" appearance="outline">
                <mat-label for="emailInput">Email address</mat-label>
                <input
                    matInput
                    type="email"
                    inputmode="email"
                    autocomplete="email"
                    id="emailInput"
                    placeholder="name@example.com"
                    name="email"
                    [(ngModel)]="email"
                    data-testid="Authentication-EmailInput"
                >
            </mat-form-field>

            <div>
                <p class="text-danger">{{error}}</p>
            </div>

            <button class="w-100 btn btn-lg btn-primary" type="submit" (click)="request()" [disabled]="loading" data-testid="Authentication-SignInButton">
                Sign in
            </button>

            <p class="mt-5 mb-3 text-muted">&copy; {{year}} weavix™</p>
        </form>
    </main>

    <main class="form-signin" *ngIf="step === 2">
        <form>
            <img class="mb-4" src="/assets/logo_dark.png" alt="" height="57">

            <p>We've emailed a validation code to {{email}}</p>

            <mat-form-field class="w-100" appearance="outline">
                <mat-label>Validation Code</mat-label>
                <input
                    matInput
                    type="text"
                    inputmode="numeric"
                    autocomplete="one-time-code"
                    id="codeInput"
                    placeholder="xxxxxx"
                    name="code"
                    [(ngModel)]="code"
                    data-testid="Authentication-ShortCodeInput"
                >
            </mat-form-field>

            <div>
                <p class="text-danger">{{error}}</p>
            </div>

            <button class="w-100 btn btn-lg btn-primary" type="submit" (click)="validate()"
                [disabled]="loading" data-testid="Authentication-ValidateButton">Validate Identity</button>

            <p class="mt-5 mb-3 text-muted">&copy; {{year}} weavix™</p>
        </form>
    </main>

</div>
